import {
  Avatar,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  makeStyles,
  withWidth,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import FullScreenDialog from "../../../components/FormDialog/FormDialog";
import parse from "html-react-parser";
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';

function PrintOrderDialog(props) {
  const { docTitle, template, width, proceed } = props;
  const [openDialog, setOpenDialog] = React.useState(true);

  const printArea = React.useRef();

  const handleCloseDialog = () => {
    setOpenDialog(false);
    proceed();
  };

  const handleClickDownload = () => {};

  return (
    <div>
      <FullScreenDialog
        disableBackdropClick
        fullScreen={width === "sm" || width === "xs"}
        maxWidth={"md"}
        title={props.title}
        scroll="body"
        open={openDialog}
        handleClose={handleCloseDialog}
      >
        <DialogContent style={{ padding: "24px" }}>
          <Grid
            container
            item
            xs={12}
            justify="center"
            alignItems="center"
            direction="column"
          >
            <div className="w-100 d-block" ref={printArea}>
              {parse(template)}
            </div>
            <div className="d-block py-3 text-center">

              <ReactToPrint
                documentTitle={docTitle}
                trigger={() => (
                  <button type="button" className="btn btn-dark mr-2">
                    <PrintIcon style={{marginRight: 8}}/> Print
                  </button>
                )}
                content={() => printArea.current}
              />
            </div>
          </Grid>
        </DialogContent>
      </FullScreenDialog>
    </div>
  );
}

PrintOrderDialog.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function showPrintOrderDialog(docTitle, template, options = {}) {
  return createConfirmation(confirmable(withWidth()(PrintOrderDialog)))({
    docTitle,
    template,
    ...options,
  });
}
